@import 'styles/mixins';
@import 'styles/blaze/mixins';

.fullScreenPreview {
  @include blur(15px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(243, 245, 246, 0.93);
  z-index: 1000;
}

.chatContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--chat-width);
  height: 100vh;
  background: var(--light-100);
  z-index: 1000;
}

.designPreviewContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: var(--post-max-width);
  aspect-ratio: var(--aspect-ratio);
  width: var(--post-max-width);
  border-radius: 20px;

  position: relative;
}

.hasToolbar {
  /* Keep a stable vertical axis so the toolbar doesn't shift */
  min-height: calc(100vh - 245px);
}

.designPreviewContainer {
  min-width: calc(100% - 500px);
  border: none;
  box-shadow: none;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  &.chatOpen {
    width: calc(100% - var(--chat-width));
    left: var(--chat-width);
  }

  .carouselItem {
    @include transition(0.3s);
    @include hide-scrollbar;
    position: absolute;
    will-change: position, transform, scale, opacity;
  }

  .hiddenRight {
    right: -150%;
    scale: 0.4;
  }

  .hiddenLeft {
    right: 150%;
    scale: 0.4;
  }
}

.nextFileContainer {
  right: 0;
  scale: 0.4;
  opacity: 0.4;
  transform-origin: right;
  transform: translateX(calc(100% - 60px));
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
}

.centerFileContainer {
  scale: 1;
  opacity: 1;
  right: 50%;
  transform-origin: center;
  transform: translateX(50%);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &.isCenterFilePortraitPreview {
    height: 100%;
    overflow: auto;
    padding: 130px 0 120px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    max-width: 835px;

    &.showScheduledPostTargetPreview {
      padding: 130px 0 250px 0;
    }
  }
}

.previousFileContainer {
  right: 100%;
  transform: translateX(60px);
  transform-origin: right;
  scale: 0.4;
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
}

.isSideFileArticlePreview {
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  opacity: 0.75;
}
.multiPlatformPreview {
  position: relative;
  width: 100%;
  min-height: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platformPreviewOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease-in-out;
}

.activePlatform {
  opacity: 1;
  z-index: 10;
  position: static;
  width: 100%;
  height: auto;
  border: 1px solid var(--dark-8);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 20px 80px 0px rgba(0, 0, 0, 0.1);
}

.inactivePlatform {
  opacity: 0;
  z-index: 1;
  pointer-events: none;
}
